import {Component, Input} from '@angular/core';
import {OopSvgComponent} from "src/app/presentation/common/icons/oop-svg/oop-svg.component";
import {StoppedMovingSvgComponent} from "src/app/presentation/common/icons/stopped-moving-svg/stopped-moving-svg.component";
import {AbnormalActivitySvgComponent} from "src/app/presentation/common/icons/abnormal-activity-svg/abnormal-activity-svg.component";
import { ToRelativeTimePipe } from "src/app/presentation/common/pipes/ToRelativeTimePipe";

@Component({
  selector: 'app-animal-alerts-bar',
  standalone: true,
  imports: [
    OopSvgComponent,
    StoppedMovingSvgComponent,
    AbnormalActivitySvgComponent,
    ToRelativeTimePipe
],
  templateUrl: './animal-alerts-bar.component.html',
  styleUrl: './animal-alerts-bar.component.css'
})
export class AnimalAlertsBarComponent {

  @Input() stoppedMovingSince?: Date;
  @Input() outOfBoundsSince?: Date;
  @Input() abnormalActivitySince?: Date;
  @Input() abnormalActivityIsHigh?: boolean;
}
